@if (loading) {
    <div style="position: relative;height: 400px;width:100%;">
        <spinner-overlay [overlay]="true"></spinner-overlay>
    </div>
}@else {
    <app-bubble-chart [nodeData]="[data]" [maxValue]="maxValue" [axislabels]="labels" [size]="['100%', 'max(420px, 58vh)']" (selectNodeEvent)="onSelect($event)"></app-bubble-chart>
}
